import { ZONES, productHref } from "./config.js";
const ICONS = {
  globe:
    '<circle cx="12" cy="12" r="9"/><ellipse cx="12" cy="12" rx="4" ry="9"/><path d="M3 12h18"/>',
  arrow: '<path d="M5 12h14m-6-6 6 6-6 6"/>',
  sound:
    '<path d="M11 5 6 9H3v6h3l5 4V5Zm4 3c3 2 3 6 0 8m3-11c5 4 5 10 0 14"/>',
  muted: '<path d="M11 5 6 9H3v6h3l5 4V5Zm5 4 5 6m0-6-5 6"/>',
  close: '<path d="m6 6 12 12M6 18 18 6"/>',
  home: '<path d="m3 11 9-8 9 8M5 10v10h5v-6h4v6h5V10"/>',
  tree: '<path d="M12 20v-7M8 20h8M6 14a4 4 0 0 1-1-8 7 7 0 0 1 13 0 4 4 0 0 1 0 8Z"/>',
  star: '<path d="m12 3 2.8 5.7L21 9.6l-4.5 4.4 1.1 6.2-5.6-3-5.6 3 1.1-6.2L3 9.6l6.2-.9Z"/>',
  boat: '<path d="m3 15 4 6h10l4-6H3Zm9-12v12m0-12 7 9h-7"/>',
  phone:
    '<rect x="6" y="2" width="12" height="20" rx="3"/><path d="M10 18h4"/>',
  flower:
    '<path d="M12 20v-7m0 4 5-2M8 6c-3-6-8 1-3 3-4 4 2 8 5 4 3 4 9 0 5-4 5-2 0-9-3-3Z"/>',
  spark: '<path d="m12 3 2.2 6.8L21 12l-6.8 2.2L12 21l-2.2-6.8L3 12l6.8-2.2Z"/>',
  pencil: '<path d="m15 4 5 5M4 20l5-1L21 7a2.1 2.1 0 0 0-5-3L4 16l0 4ZM4 16l5 3"/>',
  info: '<circle cx="12" cy="12" r="9"/><path d="M12 11v6m0-10v.1"/>',
  gear: '<path d="M4 7h16M4 17h16M8 4v6m8 4v6"/>',
};
export const icon = (name) =>
  `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">${ICONS[name] || ICONS.star}</svg>`;
const compactLabels = ["入口", "灵感", "创作", "作品", "分享", "口袋", "花园"];
const symbols = ["home", "tree", "pencil", "star", "boat", "phone", "flower"];
const touchLabels = {
  welcome: "亮起来",
  inspiration: "摘灵感",
  studio: "看过程",
  works: "换造景",
  share: "放纸船",
  pocket: "看设备",
  quiet: "叫醒花",
};
export class UI {
  constructor(callbacks) {
    this.callbacks = callbacks;
    this.current = null;
    this.step = 0;
    this.returnFocus = null;
    this.origin = import.meta.env.VITE_PRODUCT_ORIGIN;
    document.querySelector("#app-ui").innerHTML = `
    <header class="topbar"><a class="brand" href="#" aria-label="Mimico 回到入口"><img src="/island/icon.png" alt=""/><span>mimico</span></a><div class="top-actions"><button id="overview" class="icon-button" aria-label="查看整颗星球" title="查看整颗星球">${icon("globe")}</button><button id="sound" class="icon-button" aria-label="开启声音" aria-pressed="false">${icon("muted")}</button><button id="quality" class="icon-button" aria-label="切换轻量画质" aria-pressed="false">${icon("gear")}</button><a class="product-link top-cta" data-path="/">打开 Mimico ${icon("arrow")}</a></div></header>
    <div id="loading" class="loading-status" role="status"><span class="loading-dot"></span><span id="loading-text">正在唤醒小星球…</span><button id="retry" hidden>重新加载</button></div>
    <div id="hint" class="interaction-hint" hidden>
      <button id="interact" class="hint-action"><span id="hint-action"></span><kbd>E</kbd></button>
      <button id="details" class="hint-info" aria-label="查看介绍">${icon("info")}</button>
    </div>
    <nav class="places" aria-label="小星球地点"><div class="places-list">${ZONES.map((z, i) => `<button data-zone="${z.id}" aria-label="前往${z.name}" ${i === 0 ? 'aria-current="location"' : ""}><span class="place-symbol">${icon(symbols[i])}</span><span class="place-label">${compactLabels[i]}</span></button>`).join("")}</div></nav>
    <div id="joystick" aria-label="拖动摇杆移动小女孩" role="group"><span></span></div>
    <button id="touch-interact" aria-label="靠近地点后互动" disabled>${icon("spark")}<span id="touch-label">互动</span></button>
    <div id="toast" role="status" aria-live="polite"></div>
    <dialog id="zone-panel" aria-labelledby="panel-title">
      <button id="close-panel" class="icon-button" aria-label="关闭介绍">${icon("close")}</button>
      <div class="panel-place" id="panel-place"></div>
      <h2 id="panel-title"></h2>
      <p id="panel-description"></p>
      <div class="demo-box">
        <strong id="demo-title"></strong>
        <p id="demo-copy" aria-live="polite"></p>
        <div id="demo-steps"></div>
      </div>
      <button id="demo-action" class="primary-button"></button>
      <a id="panel-link" class="panel-link" hidden></a>
      <details id="more"><summary>还有更多创作方式</summary><p>已完成的 Web 体验，也可以通过 Mimico CLI 上传、构建与发布。API Token 在产品的设置中创建。</p></details>
    </dialog>
  `;
    this.panel = document.querySelector("#zone-panel");
    document.querySelectorAll("[data-zone]").forEach((b) =>
      b.addEventListener("click", () => {
        this.close();
        callbacks.travel(b.dataset.zone);
        this.hideIntro();
      }),
    );
    document.querySelector(".brand").addEventListener("click", (e) => {
      e.preventDefault();
      this.close();
      callbacks.travel("welcome");
    });
    document.querySelector("#overview").onclick = () => callbacks.overview();
    document.querySelector("#sound").onclick = () => callbacks.sound();
    document.querySelector("#quality").onclick = () => callbacks.quality();
    document.querySelector("#retry").onclick = () => callbacks.retry();
    for (const id of ["interact", "touch-interact"])
      document.querySelector(`#${id}`).onclick = () => callbacks.interact();
    document.querySelector("#details").onclick = () => callbacks.details();
    document.querySelector("#close-panel").onclick = () => this.close();
    this.panel.addEventListener("cancel", (e) => {
      e.preventDefault();
      this.close();
    });
    this.panel.addEventListener("click", (e) => {
      const b = this.panel.getBoundingClientRect();
      if (
        e.clientX < b.left ||
        e.clientX > b.right ||
        e.clientY < b.top ||
        e.clientY > b.bottom
      )
        this.close();
    });
    this.panel.addEventListener("close", () => callbacks.lock(false));
    document.querySelector("#demo-action").onclick = () => {
      this.step++;
      this.renderDemo();
      callbacks.effect(this.current.id, this.step);
    };
    this.bindLink(document.querySelector(".top-cta"), "/");
  }
  bindLink(element, path) {
    const href = productHref(this.origin, path, location.origin);
    element.removeAttribute("href");
    element.onclick = null;
    const old = element.querySelector(".unavailable");
    old?.remove();
    if (href) {
      element.href = href;
      element.target = "_blank";
      element.rel = "noopener noreferrer";
      element.removeAttribute("aria-disabled");
    } else {
      element.setAttribute("aria-disabled", "true");
      element.title = "产品地址暂未配置";
      element.onclick = (e) => {
        e.preventDefault();
        this.toast("产品入口暂未配置，小星球仍可自由探索。");
      };
      element.insertAdjacentHTML(
        "beforeend",
        '<span class="unavailable">暂未开放</span>',
      );
    }
  }
  hideIntro() {
    document.body.classList.add("exploring");
  }
  setNearby(zone) {
    if (this.nearby === zone && this.nearbyPanelOpen === this.panel.open) return;
    this.nearbyPanelOpen = this.panel.open;
    this.nearby = zone;
    const hint = document.querySelector("#hint");
    const details = document.querySelector("#details");
    hint.hidden = !zone;
    hint.classList.toggle("open", this.panel.open);
    details.setAttribute("aria-pressed", String(this.panel.open));
    if (zone) {
      document.querySelector("#hint-action").textContent = zone.action;
      document.querySelector("#interact").setAttribute(
        "aria-label",
        `${zone.action}，按 E`,
      );
      details.setAttribute(
        "aria-label",
        this.panel.open ? "关闭介绍" : `查看${zone.name}介绍`,
      );
    }
    const touch = document.querySelector("#touch-interact");
    touch.disabled = !zone || this.panel.open;
    document.querySelector("#touch-label").textContent = zone
      ? touchLabels[zone.id] || "互动"
      : "互动";
    touch.setAttribute(
      "aria-label",
      zone ? zone.action : "靠近地点后互动",
    );
  }
  active(id) {
    if (this.activeId === id) return;
    this.activeId = id;
    document.querySelectorAll("[data-zone]").forEach((b) => {
      if (b.dataset.zone === id) {
        b.setAttribute("aria-current", "location");
        const list = b.parentElement;
        const item = b.getBoundingClientRect(),
          bounds = list.getBoundingClientRect();
        if (item.left < bounds.left || item.right > bounds.right)
          list.scrollTo({
            left: b.offsetLeft - list.clientWidth / 2 + b.clientWidth / 2,
            behavior: "auto",
          });
      } else b.removeAttribute("aria-current");
    });
  }
  show(zone) {
    if (!zone) return;
    this.current = zone;
    this.step = 0;
    this.returnFocus = document.activeElement;
    this.hideIntro();
    this.callbacks.lock(true);
    document.querySelector("#panel-place").textContent = zone.name;
    document.querySelector("#panel-title").textContent = zone.title;
    document.querySelector("#panel-description").textContent = zone.description;
    document.querySelector("#demo-action").textContent = zone.action;
    document.querySelector("#more").hidden = zone.id !== "studio";
    const link = document.querySelector("#panel-link");
    link.removeAttribute("href");
    link.hidden = !zone.path;
    if (zone.path) {
      link.textContent = zone.linkLabel;
      this.bindLink(link, zone.path);
    }
    this.renderDemo();
    if (!this.panel.open) this.panel.show();
    document.querySelector("#details").focus();
    this.setNearby(zone);
  }
  close() {
    if (this.panel.open) {
      this.panel.close();
      this.callbacks.lock(false);
      if (this.returnFocus?.isConnected) this.returnFocus.focus();
      this.setNearby(this.nearby);
    }
  }
  renderDemo() {
    const state = {
      welcome: [
        [
          "有光的地方，就有新的开始。",
          "那一小点光，是小女孩送给你的第一份灵感。",
        ],
      ],
      inspiration: [
        [
          "如果，星星住在花园里？",
          "走过花径，轻触星星，让一座花园慢慢亮起来。",
        ],
        [
          "做一座会唱歌的小山。",
          "不同高度发出不同音符，走一段路，就是一首小曲。",
        ],
        [
          "给小猫开一家云朵商店。",
          "挑选形状和颜色，把云朵送给今天的第一位客人。",
        ],
      ],
      studio: [
        ["描述你的想法", "例如：做一个收集星星的花园，用方向键移动。"],
        ["看见可玩的预览", "在预览中体验玩法，看看画面和操作是不是你想要的。"],
        ["调整，再分享", "继续描述想改的地方，满意后发布作品，把链接分享出去。"],
      ],
      works: [
        ["探索 · 小山的另一边", "转过山脚，看看下一段路藏着什么。"],
        ["益智 · 刚刚好的形状", "把零散的形状，拼成自己的答案。"],
        ["故事 · 敲开一扇小门", "每一次选择，都可能带来不同的故事。"],
      ],
      share: [
        [
          "一只纸船，载着一个小世界。",
          this.step
            ? "纸船出发了。真正的作品发布与分享，请前往 Mimico。"
            : "点下面的按钮，看它慢慢漂向远方。",
        ],
      ],
      pocket: [
        ["浏览器里的大世界", "用 PC 浏览器创作、发现和游玩。"],
        ["口袋里的小世界", "打开下载页，查看当前提供的移动客户端。"],
      ],
      quiet: [
        ["花儿还在打盹。", "轻轻叫醒它们，看看这一簇暖暖的小光。"],
        [
          "有些美好，不需要一个理由。",
          "这里没有任务，也没有倒计时。陪花儿待一会儿吧。",
        ],
      ],
    }[this.current.id];
    const [title, copy] = state[this.step % state.length];
    document.querySelector("#demo-title").textContent = title;
    document.querySelector("#demo-copy").textContent = copy;
    document.querySelector("#demo-steps").innerHTML = state
      .map(
        (_, i) =>
          `<i class="${i === this.step % state.length ? "selected" : ""}"></i>`,
      )
      .join("");
  }
  loading(text, error = false) {
    document.querySelector("#loading").hidden = !text;
    document.querySelector("#loading-text").textContent = text;
    document.querySelector("#retry").hidden = !error;
  }
  toast(text) {
    const el = document.querySelector("#toast");
    el.textContent = text;
    el.classList.add("visible");
    clearTimeout(this.toastTimer);
    this.toastTimer = setTimeout(() => el.classList.remove("visible"), 3500);
  }
  sound(on) {
    const b = document.querySelector("#sound");
    b.innerHTML = icon(on ? "sound" : "muted");
    b.setAttribute("aria-pressed", String(on));
    b.setAttribute("aria-label", on ? "关闭声音" : "开启声音");
  }
  quality(low) {
    const b = document.querySelector("#quality");
    b.setAttribute("aria-pressed", String(low));
    b.setAttribute("aria-label", low ? "切换完整画质" : "切换轻量画质");
  }
}
